import type { ReactNode } from "react";
import type { UserStatus } from "@shared/types";

type Tone = "neutral" | "accent" | "success" | "warning" | "danger";

export function Badge({
  children,
  tone = "neutral",
  mono,
}: {
  children: ReactNode;
  tone?: Tone;
  mono?: boolean;
}) {
  return (
    <span
      className={["badge", tone !== "neutral" && `badge--${tone}`, mono && "badge--mono"]
        .filter(Boolean)
        .join(" ")}
    >
      {children}
    </span>
  );
}

const STATUS_TONE: Record<UserStatus, Tone> = {
  active: "success",
  invited: "warning",
  suspended: "danger",
};

export function StatusBadge({ status }: { status: UserStatus }) {
  return <Badge tone={STATUS_TONE[status]}>{status}</Badge>;
}
